<template>
    <div class="card-content-image">
        <img class="card-content-image__img" ref="image" :src="src" :style="styleObject" v-if="src && objectFitSupported">
        <div class="card-content-image__object-fit-fix" :style="backgroundStyleObject" v-else></div>
    </div>
</template>

<script>
    export default {
        name: 'ContentImage',
        props: {
            src: String
        },
        data () {
            return {
                objectFitSupported: true,
                styleObject: {
                    'object-fit': 'cover'
                },
                backgroundStyleObject: {
                    'background-size': 'cover',
                    'background-image': 'url()'
                }
            }
        },
        methods: {
            imageLoad (src) {
                if (!this.objectFitSupported) this.backgroundStyleObject['background-image'] = `url(${src})`;
                const image = new Image();
                let naturalWidth, naturalHeight;

                image.onload = () => {
                    naturalWidth = image.naturalWidth;
                    naturalHeight = image.naturalHeight;

                    if (naturalWidth / naturalHeight < 2.35 && naturalWidth / naturalHeight > 1.33) return;

                    this.styleObject['object-fit'] = 'contain';
                    this.backgroundStyleObject['background-size'] = 'contain';
                }

                image.src = src;
            }
        },
        mounted () {
            // Feature detect object-fit support
            if ('objectFit' in document.documentElement.style === false) {
                this.objectFitSupported = false;
            }
            if (this.src) {
                this.imageLoad(this.src);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-content-image {
        &, &__img {
            width: 100%;
            height: 130px;
        }

        background-color: $dashboard-background;
        border: 1px solid rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        border-radius: 5px 5px 0 0;
        max-height: 130px;
        overflow: hidden;
        position: relative;
        margin-bottom: $card-margin;


        &__object-fit-fix {
            height: 130px;
            width: 100%;
            position: absolute;
            background-position: center center;
            background-repeat: no-repeat;
        }
    }
</style>